export default function Footer() {
  return (
    <footer className="bg-[#0C1C15] text-white/60 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://storage.readdy-site.link/project_files/38a0fe6b-1e54-4ff4-ae8d-2258d722dfac/041ad50a-862f-4d87-b6bb-11d7913a719a_smile-logo-transparent-211x85.png?v=de4dea040c26dbb72c9fc9dbc007ad7a"
              alt="Smile By Dr. K – Orthodontics Chatsworth CA"
              className="h-10 w-auto mb-5"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p
              className="text-white/45 text-sm leading-relaxed max-w-xs mb-6"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Personalized orthodontic care for children, teens, and adults in
              Chatsworth, CA. Advanced technology. Lasting results.
            </p>
            <div className="flex gap-3">
              {['ri-facebook-line', 'ri-instagram-line', 'ri-google-line'].map((icon) => (
                <div
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center border border-white/15 rounded-full cursor-pointer hover:border-[#7BAF8B] hover:text-[#7BAF8B] transition-colors duration-200"
                >
                  <i className={`${icon} text-sm`} />
                </div>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <p
              className="text-white text-xs tracking-[0.15em] uppercase font-semibold mb-5"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Treatments
            </p>
            <ul className="flex flex-col gap-3">
              {['Braces', 'InBrace', 'Bite Correction', 'Teeth Straightening', 'Phase I &amp; II', 'Smile Assessment'].map((item) => (
                <li key={item}>
                  <a
                    href="https://smilebydrkortez.com/treatments"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm hover:text-[#7BAF8B] transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: 'DM Sans, sans-serif' }}
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p
              className="text-white text-xs tracking-[0.15em] uppercase font-semibold mb-5"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Contact
            </p>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-line text-[#7BAF8B] text-sm" />
                </div>
                <span
                  className="text-sm leading-relaxed"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  10234 Canoga Ave<br />Chatsworth, CA 91311
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#7BAF8B] text-sm" />
                </div>
                <a
                  href="tel:8183415150"
                  className="text-sm hover:text-[#7BAF8B] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  (818) 341-5150
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-video-line text-[#7BAF8B] text-sm" />
                </div>
                <a
                  href="https://smilebydrkortez.com/virtual-consult"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm hover:text-[#7BAF8B] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  Virtual Consultation
                </a>
              </li>
              <li>
                <a
                  href="https://smilebydrkortez.com/request-appointment"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-block mt-2 bg-[#7BAF8B] hover:bg-[#6A9E7A] text-[#0C1C15] font-semibold text-xs px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  Book Appointment
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-7 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-white/30 text-xs"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            &copy; {new Date().getFullYear()} Smile By Dr. K. All rights reserved. · Chatsworth, CA Orthodontist
          </p>
          <div className="flex gap-5">
            {['Privacy Policy', 'Sitemap'].map((item) => (
              <a
                key={item}
                href="https://smilebydrkortez.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-white/30 text-xs hover:text-white/60 transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
